<template>
    <div>
        <div class="white-box md:mb-5 pb-12 md:pb-6">
            <transition name="opacity" mode="out-in">
                <Skeletons v-if="isLoadingData" />
                <div v-else>
                    <div>
                        <Frame v-model:isOpen="isOpenChange" title="目前設定的給付方式" button-position="mt-2.5"
                            @resetValues="cancelChange">
                            <template #data>
                                <CustomTable :is-border="false" :cursor-pointer="false" class="xs:text-lg">
                                    <template #thead>
                                        <tr class="hidden md:table-row">
                                            <td class="flex justify-between md:px-4">
                                                <p class="w-3/5">標的名稱</p>
                                                <p class="w-2/5">
                                                    給付方式
                                                </p>
                                                <p class="w-1/5">
                                                    比例
                                                </p>
                                            </td>
                                        </tr>
                                    </template>
                                    <template #tbody>
                                        <tr v-for="(item, index) in showData.payDividendList" v-show="item.inPolicy"
                                            :key="index" class="even:bg-white">
                                            <td class="md:px-4">
                                                <div class="flex justify-between">
                                                    <div class="w-3/5">
                                                        {{ `${item.fundCode} ${item.fundName}` }}
                                                    </div>
                                                    <div class="w-2/5">
                                                        {{ item.divKindText }}
                                                    </div>
                                                    <div class="w-1/5">
                                                        {{ item.divKind === 4 ? item.percent:'' }}                                                        
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </CustomTable>
                            </template>
                            <template #inputs>
                                <div class="divide-y divide-dashed border-b mb-5">
                                    <div v-for="(item, index) in userData.payDividendList" :key="index"
                                        class="flex justify-between">
                                        <div class="w-3/5">
                                            <span class="xs:text-lg md:mr-8">{{ `${item.fundCode} ${item.fundName}`
                                            }}</span>
                                        </div>
                                        <div class="w-2/5 pr-5 flex items-center">
                                            <Multiselect v-model="item.divKind" :options="item.typeDetailList"
                                                :can-clear="false" :can-deselect="false" class="select-base ml-0"
                                                placeholder="請選擇給付方式" @select="resetData(item)" />
                                            <p class="text-error text-right">{{ item.errorMessage }}</p>
                                        </div>
                                        <div class="w-1/5 flex items-center">
                                            <input v-model.trim="item.percent" inputmode="numeric" autocomplete="off"
                                                :disabled="item.disabledPercent"
                                                class="input-base" maxlength="3"
                                            >
                                            <svg class="fill-current overflow-hidden w-5 h-5 -ml-6" data-v-429f5bac="">
                                                <use xlink:href="#percent" data-v-429f5bac=""></use>
                                            </svg>                                            
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </Frame>
                    </div>
                </div>
            </transition>
        </div>
        <Bottombar>
            <template #right>
                <ButtonNextService v-model:isSubmitOk="isSubmitOk" v-model:isGetButtonInfo="isGetButtonInfo"
                    :disabled="!isOpenChange || !hasChangeData" @click="validGoNext" />
            </template>
        </Bottombar>
        <Loading :is-loading="isLoading" />
        <PopupBase v-model:visiblePopup="visiblePopup" :params="{
            title: '重要提醒',
            confirmButton: dialogSetting.confirmButton,
            cancelButton: dialogSetting.cancelButton,
        }" closeicon @cancel="cancelPopup" @confirm="confirmPopup" @handleClose="visiblePopup = false">
            <template #content>
                <div>{{ confirmMsgList[0] }}</div>
                <div class="mt-5 text-green-600 font-medium mr-4">
                    {{ confirmMsgList[1] }}
                </div>
            </template>
        </PopupBase>
    </div>
</template>

<script>
import { computed, reactive, toRefs, inject, watch, ref } from 'vue-demi';
import { getInfoAG, submitAG } from '@/apis/AG';
import { addAndInsertService } from '@/utils/changeItems/insertService';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import Skeletons from './Skeletons.vue';
import Frame from '@/components/collapse/CollapseFrame.vue';
import CustomTable from '@/components/table/Table.vue';
import Multiselect from '@vueform/multiselect';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import Bottombar from '@/components/layout/Bottombar.vue';
import Loading from '@/components/Loading.vue';
import PopupBase from '@/components/dialogs/Popup.vue';
import _ from 'lodash';

export default {
    components: {
        Skeletons,
        Frame,
        CustomTable,
        Multiselect,
        ButtonNextService,
        Bottombar,
        Loading,
        PopupBase
    },
    setup() {
        const route = useRoute();
        const { code } = route.meta;
        const store = useStore();
        const $vfm = inject('$vfm');
        const state = reactive({
            isLoadingData: false,
            isLoading: false,
            isOpenChange: false,
            isSubmitOk: false,
            isGetButtonInfo: false,
            isInsertSuccess: false,
            visiblePopup: false,
            confirmType: 0,
            confirmMsgList: '',
        });
        const data = reactive({
            showData: {},
            userData: {
                payDividendList: [{
                    fundCode: '',
                    divKind: 0,
                    percent: 0,
                    typeDetailList: [{
                        type: '',
                        text: ''
                    }]
                }]
            },
            errorDataRow: [],
            errorText: '',
        });
        const dialogSetting = computed(() => {
            let dialogSetting = {};
            if (state.confirmType === 1) {
                dialogSetting = {
                    confirmButton: '立即約定',
                    cancelButton: '重新選擇'
                };
            }
            if (state.confirmType === 2) {
                dialogSetting = {
                    confirmButton: '確定',
                    cancelButton: '我要變更'
                };
            }
            return dialogSetting;
        });
        const result = computed(() => store.state.services.changeItemsResult[code]);

        /** 取得頁面資料 */
        const getData = async () => {
            state.isLoadingData = true;

            /** user資料 */
            await getInfoAG().then((res) => {
                if (res.data) {
                    data.showData.payDividendList = _.cloneDeep(res.data.payDividendList);
                    data.userData.payDividendList = res.data.payDividendList.map(i => {
                        const obj = {
                            fundCode: i.fundCode,
                            fundName: i.fundName,
                            divKind: i.divKind,
                            percent: i.percent,
                            typeDetailList: i.typeDetailList?.map(v => {
                                v.value = v.type;
                                v.label = v.text;
                                return v;
                            }),
                            errorMessage: ''
                        };
                        return obj;
                    });

                    const key = Object.keys(res.data);
                    const userDatakey = Object.keys(data.userData);
                    key.forEach(i => {
                        data.userData[i] = resetForm(res.data[i]);
                    });                    

                }
                state.isLoadingData = false;
            }).catch((err) => {
                console.log(err);
                state.isLoadingData = false;
            });
        };

        /** 返回修改 */
        if (!result.value) {
            getData();
        } else {
            const { dividendInfoList, showData, userData } = result.value;
            state.isOpenChange = true;
            data.dividendInfoList = dividendInfoList;
            data.showData = _.cloneDeep(showData);
            data.userData = _.cloneDeep(userData);
        }

        const hasChangeData = computed(() => {
            const showData = data.showData.payDividendList;
            const userData = data.userData.payDividendList;
            const dbData = showData.length !== 0 ? JSON.stringify(showData.map(i => i.divKind)) : '';
            const changeData = userData.length !== 0 ? JSON.stringify(userData.map(i => i.divKind)) : '';
            if(dbData === changeData) {                            
                let checks = showData.map(item=>{
                    return userData.some(i => item.divKind == i.divKind && item.fundCode == i.fundCode && item.percent == (i.percent?i.percent.toString():0));
                });
                
                // 確認是否有變更資料
                return checks.some(p => p === false);

            }
            return true;
        });

        /** 下一步 檢查錯誤與是否有修改資料 */
        const validGoNext = () => {
            data.userData.payDividendList.forEach(i => {
                if (i.divKind === 0) {
                    i.errorMessage = '請選擇給付方式';
                    data.errorDataRow.push(i.fundCode);
                }
            });
            const hasError = data.userData.payDividendList.some(i => i.errorMessage !== '');
            if (hasError) {
                data.errorText = data.errorDataRow.join('、') + ' 請輸入配息/提解給付方式';
                modalShow({
                    title: '提示',
                    content: data.errorText,
                    confirmButton: '確認',
                    cancelButton: null,
                    closeicon: true,
                });
            } else {
                submit();
            }
        };

        /** 送出資料 */
        const submit = () => {
            state.isLoading = true;
            const payDividendList = data.userData.payDividendList.map(i => {
                return {
                    fundCode: i.fundCode,
                    divKind: i.divKind,
                    percent: i.percent
                };
            });
            const returnData = {
                payDividendList: payDividendList
            };
            submitAG(returnData).then(res => {
                state.isLoading = false;

                if (res.data.confirmType === 0) {
                    state.isSubmitOk = true;
                } else {
                    state.confirmType = res.data.confirmType;
                    state.confirmMsgList = res.data.confirmMsgList;
                    state.visiblePopup = true;
                }

                // 存store
                const storeData = {};
                storeData.dividendInfoList = data.dividendInfoList;
                storeData.showData = data.showData;
                storeData.userData = data.userData;
                store.dispatch('services/setChangeItemsResult', { code, value: storeData });
            }).catch(() => {
                state.isLoading = false;
            });
        };

        /** 取消燈箱 */
        const cancelPopup = async () => {
            state.visiblePopup = false;
            if (state.confirmType === 1) return;
            if (state.confirmType === 2) {
                /** 執行加入服務 */
                // addAndInsertService('B5', code);
                state.isLoading = true;
                await addAndInsertService('B5', code);
                state.isLoading = false;
            }
        };

        /** 確認燈箱 */
        const confirmPopup = async () => {
            state.visiblePopup = false;
            if (state.confirmType === 1) {
                /** 執行加入服務 */
                state.isLoading = true;
                await addAndInsertService('B5', code);
                state.isLoading = false;
            } else if (state.confirmType === 2) {
                state.isSubmitOk = true;
            }
        };

        watch(() => state.isGetButtonInfo, (nV) => {
            // 當isGetButtonInfo完成抓按鈕資料，變成false後,state.isInsertSuccess為true才下一步
            if (!nV && state.isInsertSuccess) state.isSubmitOk = true;
        }, { immediate: true });

        /** 取消變更 */
        const cancelChange = () => {
            data.userData.payDividendList = data.showData.payDividendList.map(i => {                
                return {
                    fundCode: i.fundCode,
                    fundName: i.fundName,
                    divKind: i.divKind,
                    typeDetailList: i.typeDetailList?.map(v => {
                        v.value = v.type;
                        v.label = v.text;
                        return v;
                    }),
                    errorMessage: ''
                };
            });
        };

        const modalShow = (params) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                        data.errorDataRow = [];
                        data.errorText = '';
                    },
                    closed() {
                        $vfm.hide('DialogBase');
                        data.errorDataRow = [];
                        data.errorText = '';
                    }
                },
            });
        };

        const resetData = (item) => {
            
            item.errorMessage = '';
            if (item.divKind === 4 ) {
                item.disabledPercent = false;
            } else {
                item.percent = 0;
                item.disabledPercent = true;
            }
        }

        /** 重設配置比例資料 */
        const resetForm = (baseList) => {
            const arr = _.cloneDeep(baseList);
            return arr.map(i => {
                i.dbData = true;
                i.errorMessage = '';
                // if (i.disableType === 3) {
                //     i.maxPercent = i.percent;
                // }
                // if (i.disableType === 0 || i.disableType === 2) {
                //     i.disabledPercent = true;
                // }
                if (i.divKind !== 4 ) {
                    i.disabledPercent = true;
                }                
                return i;
            });
        };


        return {
            ...toRefs(state),
            ...toRefs(data),
            dialogSetting,
            hasChangeData,
            cancelPopup,
            confirmPopup,
            cancelChange,
            resetData,
            validGoNext
        };
    }
};
</script>
